import React, { createContext, useState, useEffect } from 'react';
import { en } from '../locales/en';
import { fr } from '../locales/fr';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Check if user has a language preference in local storage, otherwise use browser preference
  const getInitialLanguage = () => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) return savedLanguage;
    
    // Check browser language
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang.startsWith('fr')) {
      return 'fr';
    }
    
    return 'en'; // Default to English
  };

  const [language, setLanguage] = useState(getInitialLanguage);
  const [translations, setTranslations] = useState(language === 'en' ? en : fr);

  // Update the language in localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('language', language);
    setTranslations(language === 'en' ? en : fr);
    document.documentElement.lang = language;
  }, [language]);

  // Toggle language function
  const toggleLanguage = () => {
    setLanguage(prevLang => prevLang === 'en' ? 'fr' : 'en');
  };

  const value = { language, toggleLanguage, translations };
  
  return (
    <LanguageContext.Provider value={value}>
      {typeof children === 'function' ? children(value) : children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
